require('./RAContributionBarArrows.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

const RAContributionBarArrows = ({ size, reverse }) => {
    const s = parseInt(size * 0.7, 10);

    const className = classnames('ra-contribution-bar-arrows', {
        'ra-contribution-bar-arrows--reverse': reverse,
    });
    const arrowClassName = classnames('ra-contribution-bar-arrows__arrow', {
        'ra-contribution-bar-arrows__arrow--left': !reverse,
        'ra-contribution-bar-arrows__arrow--right': reverse,
    });

    const arrows = new Array(3)
        .fill(0)
        .map((_, i) => <div key={i} className={arrowClassName} style={{ height: s, width: s }} />);

    return <div className={className}>{arrows}</div>;
};

RAContributionBarArrows.propTypes = {
    size: PropTypes.number.isRequired,
    reverse: PropTypes.bool,
};

module.exports = RAContributionBarArrows;
